import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import BigK from '../assets/images/Big-K.svg';
import LogoWhite from '../assets/images/Ark-Logo-white.svg';
import SocialMedia from '../assets/images/Social-Media-Icons.svg';

export const FooterSection = () => {
  return (
    <div className="footer-section">
      <div className="presenter-container footer">
        <div className="footer-box">
          <div className="shadow-con-left">
            <img src={LogoWhite} loading="lazy" alt="" className="footer-ark-icon" />
            <div className="text-block-30 footer">Making Payments easy since 2020</div>
            <div className="text-block-25 footer">
              Sveavägen 46
              <br />
              111 34 Stockholm
              <br />
              Sweden
            </div>
            <img src={SocialMedia} loading="lazy" alt="" className="socialmeadi-icon" />
          </div>
          <img src={BigK} loading="lazy" height="" alt="" className="box-image-right footer" />
        </div>
        <div className="text-block-20">Copyright Ark Payments Stockholm 2020</div>
      </div>
    </div>
  );
};
